<fe-header style="z-index: 10000"></fe-header>
<main>
    <fe-card-landing-title
        [title]="'Programa de renta de autos para empresas'"
        [imageSrc]="'images/banner_empresas_header.jpg' | cdn"
    ></fe-card-landing-title>
    <div class="enterprises" id="sectionForm">
        <section class="enterprises__form container py-4 px-0 px-md-4 px-lg-8">
            <fe-hbsptform></fe-hbsptform>
        </section>
    </div>
    <section class="enterprises__benefits">
        <div class="enterprises__benefits__content container py-4">
            <div class="container-xl">
                <div class="row">
                    <div
                        class="col-12 col-lmd-5 d-flex flex-column align-items-start justify-content-center px-0 px-lmd-8"
                    >
                        <h2>
                            {{ 'fe_enterprises_title' | translate }}
                        </h2>
                        <fe-button
                            class="d-flex pt-3"
                            [href]="'/es/empresas'"
                            [fragment]="'sectionForm'"
                            [style]="'primary'"
                            >{{
                                'fe_enterprises_button' | translate
                            }}</fe-button
                        >
                    </div>
                    <div
                        class="col-12 col-lmd-7 d-none d-lmd-flex justify-content-center"
                    >
                        <img
                            [src]="'images/programa_empresas.png' | cdn"
                            alt="Guy turning on the AC"
                        />
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section class="enterprises__register">
        <div class="enterprises__register__content container py-4">
            <div class="container-xl">
                <div class="row">
                    <div class="col-12">
                        <h2>
                            {{ 'fe_enterprises_register_title' | translate }}
                        </h2>
                        <hr />
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-lmd-4 d-flex">
                        <div class="bg-white p-4 flex-fill">
                            <h3>
                                {{
                                    'fe_enterprises_register_first_number'
                                        | translate
                                }}
                            </h3>
                            <h3>
                                {{
                                    'fe_enterprises_register_first_info'
                                        | translate
                                }}
                            </h3>
                            <p>
                                {{
                                    'fe_enterprises_register_first_description'
                                        | translate
                                }}
                            </p>
                        </div>
                    </div>
                    <div class="col-12 col-lmd-4 d-flex py-4 py-lmd-0">
                        <div class="bg-white p-4 flex-fill">
                            <h3>
                                {{
                                    'fe_enterprises_register_second_number'
                                        | translate
                                }}
                            </h3>
                            <h3>
                                {{
                                    'fe_enterprises_register_second_info'
                                        | translate
                                }}
                            </h3>
                            <p>
                                {{
                                    'fe_enterprises_register_second_description'
                                        | translate
                                }}
                            </p>
                        </div>
                    </div>
                    <div class="col-12 col-lmd-4 d-flex">
                        <div class="bg-white p-4 flex-fill">
                            <h3>
                                {{
                                    'fe_enterprises_register_third_number'
                                        | translate
                                }}
                            </h3>
                            <h3>
                                {{
                                    'fe_enterprises_register_third_info'
                                        | translate
                                }}
                            </h3>
                            <p>
                                {{
                                    'fe_enterprises_register_third_description'
                                        | translate
                                }}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div
                        class="col-12 d-flex justify-content-center align-items-center"
                    >
                        <fe-button
                            class="d-none d-lmd-flex pt-4"
                            [href]="'/es/empresas'"
                            [fragment]="'sectionForm'"
                            [style]="'primary'"
                            >{{
                                'fe_enterprises_button' | translate
                            }}</fe-button
                        >
                        <a
                            [href]="'/es/empresas#sectionForm'"
                            class="btn__footer d-flex d-lmd-none justify-content-center mt-3"
                            >{{ 'fe_enterprises_button' | translate }}</a
                        >
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section class="enterprises__benefits">
        <div class="enterprises__benefits__content container py-4">
            <div class="container-xl">
                <div class="row">
                    <div class="col-12 col-lmd-6 d-none d-lmd-flex">
                        <img
                            [src]="'images/beneficios_imagen.jpg' | cdn"
                            alt="Guy inside a car doing a thumbs up gesture"
                        />
                    </div>
                    <div class="col-12 col-lmd-6">
                        <div
                            class="d-flex flex-column align-items-start justify-content-start ps-0 ps-lmd-1"
                        >
                            <h4>
                                {{
                                    'fe_enterprises_benefits_title' | translate
                                }}
                            </h4>
                            <h2>
                                {{
                                    'fe_enterprises_benefits_subtitle'
                                        | translate
                                }}
                            </h2>
                            <ul class="m-0 ps-3">
                                <li>
                                    {{
                                        'fe_enterprises_benefits_li_first'
                                            | translate
                                    }}
                                </li>
                                <li>
                                    {{
                                        'fe_enterprises_benefits_li_second'
                                            | translate
                                    }}
                                </li>
                                <li>
                                    {{
                                        'fe_enterprises_benefits_li_third'
                                            | translate
                                    }}
                                </li>
                                <li>
                                    {{
                                        'fe_enterprises_benefits_li_fourth'
                                            | translate
                                    }}
                                </li>
                                <li>
                                    {{
                                        'fe_enterprises_benefits_li_fifth'
                                            | translate
                                    }}
                                </li>
                                <li>
                                    {{
                                        'fe_enterprises_benefits_li_sixth'
                                            | translate
                                    }}
                                </li>
                                <li>
                                    {{
                                        'fe_enterprises_benefits_li_seventh'
                                            | translate
                                    }}
                                </li>
                                <li>
                                    {{
                                        'fe_enterprises_benefits_li_eighth'
                                            | translate
                                    }}
                                </li>
                                <li>
                                    {{
                                        'fe_enterprises_benefits_li_ninth'
                                            | translate
                                    }}
                                </li>
                                <li>
                                    {{
                                        'fe_enterprises_benefits_li_tenth'
                                            | translate
                                    }}
                                </li>
                                <li>
                                    {{
                                        'fe_enterprises_benefits_li_eleventh'
                                            | translate
                                    }}
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section class="enterprises__strip">
        <div
            class="enterprises__strip__content container py-2 px-0 px-md-4 px-lg-8"
        >
            <div class="container-xl">
                <div class="row align-items-stretch">
                    <div class="col-12 col-md-6 py-4">
                        <div class="d-flex flex-row align-items-start h-100">
                            <img
                                class="me-2 me-md-4 align-self-center"
                                [src]="'images/custom-service.svg' | cdn"
                                alt="Stretching hands icon"
                            />
                            <div class="d-flex flex-column">
                                <h3>
                                    {{
                                        'fe_enterprises_strip_title_1'
                                            | translate
                                    }}
                                </h3>
                                <p>
                                    {{
                                        'fe_enterprises_strip_paragraph_1'
                                            | translate
                                    }}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 py-4">
                        <div class="d-flex flex-row align-items-start h-100">
                            <img
                                class="me-2 me-md-4 align-self-center"
                                [src]="'images/call-service.svg' | cdn"
                                alt="Stretching hands icon"
                            />
                            <div class="d-flex flex-column">
                                <h3>
                                    {{
                                        'fe_enterprises_strip_title_2'
                                            | translate
                                    }}
                                </h3>
                                <p>
                                    {{
                                        'fe_enterprises_strip_paragraph_2'
                                            | translate
                                    }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <fe-cars-cards></fe-cars-cards>
    <section class="enterprises__insurance">
        <div class="enterprises__insurance__content container py-4">
            <div
                class="d-flex flex-row justify-content-between align-items-end pb-4 pe-4"
            >
                <h2 class="m-0 pb-1">
                    {{ 'fe_enterprises_insurance_title' | translate }}
                </h2>
            </div>
            <div class="container-xl">
                <div class="row">
                    <div class="col-12 col-lmd-6 d-flex align-items-center">
                        <div class="row w-100">
                            <div class="col-lmd-4 d-none d-lmd-grid card__blue">
                                <div
                                    class="d-flex flex-column pt-4 align-items-center justify-content-center h-100"
                                >
                                    <p class="p__title m-0">
                                        {{
                                            'fe_enterprises_insurance_first_card_percent_number'
                                                | translate
                                        }}<span>{{
                                            'fe_enterprises_insurance_first_card_percent_symbol'
                                                | translate
                                        }}</span>
                                    </p>
                                    <p class="p__subtitle m-0">
                                        {{
                                            'fe_enterprises_insurance_first_card_percent_deducible'
                                                | translate
                                        }}
                                    </p>
                                </div>
                            </div>
                            <div
                                class="col-12 col-lmd-8 card__white bg-white p-3 px-3 px-lmd-4 h-100"
                            >
                                <div
                                    class="d-flex flex-column align-items-start justify-content-start"
                                >
                                    <h3 class="deducible d-lmd-none m-0 ps-1">
                                        {{
                                            'fe_enterprises_insurance_first_card_percent_join'
                                                | translate
                                        }}
                                    </h3>
                                    <h3 class="m-0 ps-1">
                                        {{
                                            'fe_enterprises_insurance_first_card_percent_insurance'
                                                | translate
                                        }}
                                    </h3>
                                    <ul class="m-0 ps-4">
                                        <li>
                                            {{
                                                'fe_enterprises_insurance_first_card_percent_insurance_li_1'
                                                    | translate
                                            }}
                                        </li>
                                        <li>
                                            {{
                                                'fe_enterprises_insurance_first_card_percent_insurance_li_2'
                                                    | translate
                                            }}
                                        </li>
                                        <li>
                                            {{
                                                'fe_enterprises_insurance_first_card_percent_insurance_li_3'
                                                    | translate
                                            }}
                                        </li>
                                        <li>
                                            {{
                                                'fe_enterprises_insurance_first_card_percent_insurance_li_4'
                                                    | translate
                                            }}
                                        </li>
                                        <li>
                                            {{
                                                'fe_enterprises_insurance_first_card_percent_insurance_li_5'
                                                    | translate
                                            }}
                                        </li>
                                        <li>
                                            {{
                                                'fe_enterprises_insurance_first_card_percent_insurance_li_6'
                                                    | translate
                                            }}
                                        </li>
                                        <li>
                                            {{
                                                'fe_enterprises_insurance_first_card_percent_insurance_li_7'
                                                    | translate
                                            }}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lmd-6 d-flex align-items-center">
                        <div class="row w-100 h-100">
                            <div
                                class="col-lmd-4 d-none d-lmd-grid card__green"
                            >
                                <div
                                    class="d-flex flex-column pt-4 align-items-center justify-content-center h-100"
                                >
                                    <p class="p__title m-0">
                                        {{
                                            'fe_enterprises_insurance_second_card_percent_number'
                                                | translate
                                        }}<span>{{
                                            'fe_enterprises_insurance_second_card_percent_symbol'
                                                | translate
                                        }}</span>
                                    </p>
                                    <p class="p__subtitle m-0">
                                        {{
                                            'fe_enterprises_insurance_second_card_percent_deducible'
                                                | translate
                                        }}
                                    </p>
                                    <p class="p__extra m-0">
                                        {{
                                            'fe_enterprises_insurance_second_card_percent_deducible_extra'
                                                | translate
                                        }}
                                    </p>
                                </div>
                            </div>
                            <div
                                class="col-12 col-lmd-8 card__white bg-white p-3 px-3 px-lmd-4 my-3 my-lmd-0 h-100"
                            >
                                <div
                                    class="d-flex flex-column align-items-start justify-content-start"
                                >
                                    <h3
                                        class="deducible d-flex d-lmd-none align-items-center m-0 ps-1"
                                    >
                                        {{
                                            'fe_enterprises_insurance_second_card_percent_join'
                                                | translate
                                        }}
                                        <p class="m-0 ms-2">
                                            {{
                                                'fe_enterprises_insurance_second_card_percent_join_extra'
                                                    | translate
                                            }}
                                        </p>
                                    </h3>
                                    <h3 class="m-0 ps-1">
                                        {{
                                            'fe_enterprises_insurance_second_card_percent_insurance'
                                                | translate
                                        }}
                                    </h3>
                                    <ul class="m-0 ps-4">
                                        <li>
                                            {{
                                                'fe_enterprises_insurance_second_card_percent_insurance_li_1'
                                                    | translate
                                            }}
                                        </li>
                                        <li>
                                            {{
                                                'fe_enterprises_insurance_second_card_percent_insurance_li_2'
                                                    | translate
                                            }}
                                        </li>
                                        <li>
                                            {{
                                                'fe_enterprises_insurance_second_card_percent_insurance_li_3'
                                                    | translate
                                            }}
                                        </li>
                                        <li>
                                            {{
                                                'fe_enterprises_insurance_second_card_percent_insurance_li_4'
                                                    | translate
                                            }}
                                        </li>
                                        <li>
                                            {{
                                                'fe_enterprises_insurance_second_card_percent_insurance_li_5'
                                                    | translate
                                            }}
                                        </li>
                                        <li>
                                            {{
                                                'fe_enterprises_insurance_second_card_percent_insurance_li_6'
                                                    | translate
                                            }}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        class="col-12 d-none d-lmd-flex justify-content-center ps-0 pe-4 pt-4"
                    >
                        <fe-button
                            [href]="'/es/empresas'"
                            [fragment]="'sectionForm'"
                            [style]="'primary'"
                            >{{
                                'fe_enterprises_button' | translate
                            }}</fe-button
                        >
                    </div>
                    <div class="col-12 d-flex d-lmd-none ps-0 pe-4 pt-4">
                        <a
                            [href]="'/es/empresas#sectionForm'"
                            class="btn__footer d-flex d-lmd-none justify-content-center"
                            >{{ 'fe_enterprises_button' | translate }}</a
                        >
                    </div>
                </div>
            </div>
        </div>
    </section>
    <fe-blog-cards></fe-blog-cards>
</main>
<fe-footer></fe-footer>
